import "./footer.css";

const Footer = () => {
return (
<div className="App">
  <footer class="footer-section">
    <div className="footer-icons">
      <a href="https://twitter.com/megha24joshi"><i class="fab fa-twitter"></i></a>
      <a href="https://github.com/Megha-Joshi"><i class="fab fa-github"></i></a>
      <a href="https://www.linkedin.com/in/megha-joshi24/"><i class="fab fa-linkedin-in"></i></a>
    </div>
    <h3 className="footer-heading"><i>The best sports are played with best sports goods!!</i></h3>
    <p className="footer-heading">© 2020 Copyright: meghajoshi</p>
  </footer>
</div>
);
};

export { Footer };